import { render, staticRenderFns } from "./uploadimg.vue?vue&type=template&id=00d64102&scoped=true"
import script from "./uploadimg.vue?vue&type=script&lang=js"
export * from "./uploadimg.vue?vue&type=script&lang=js"
import style0 from "./uploadimg.vue?vue&type=style&index=0&id=00d64102&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d64102",
  null
  
)

export default component.exports